import { render, staticRenderFns } from "./marketplace-card-portfolio-new.component.vue?vue&type=template&id=bcbe075a&scoped=true"
import script from "./marketplace-card-portfolio-new.component.vue?vue&type=script&lang=js"
export * from "./marketplace-card-portfolio-new.component.vue?vue&type=script&lang=js"
import style0 from "./marketplace-card-portfolio-new.component.vue?vue&type=style&index=0&id=bcbe075a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbe075a",
  null
  
)

export default component.exports